import React from 'react';

export const SvgPlayArrow = props => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M6 5.957v12.086a1.164 1.164 0 001.797.98l9.496-6.043c.724-.455.724-1.505 0-1.972L7.797 4.977A1.164 1.164 0 006 5.957z"
      fill="currentColor"
    />
  </svg>
);
